<template src="./review-valid-user.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import SubsidyUserDetails from '@/components/subsidy/SubsidyUserDetails'
import Vuelidate from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import { mask } from 'vue-the-mask'
import { EventBus } from '@/router/bus'

Vue.use(Vuelidate)

export default {
  name: 'review-valid-user',
  mixins: [validationMixin],
  directives: {
    mask
  },
  components: {
    ContextPage,
    SubsidyUserDetails
  },
  data () {
    return {
      pageLoader: false,
      userId: '',
      user: null,
      uniqueIdentificationNumberMask: '#############',
      retrieveUser: {
        identificationNumber: null,
        uniqueIdentificationNumber: null
      }
    }
  },
  created () {
    const uniqueIdentificationNumber = this.$route.query.uniqueIdentificationNumber
    if (typeof uniqueIdentificationNumber !== 'undefined' && uniqueIdentificationNumber !== null) {
      this.retrieveUser.uniqueIdentificationNumber = uniqueIdentificationNumber
      this.submitRetrieval()
    }

    EventBus.$on('page-loader', (loading) => {
      this.pageLoader = loading
    })
  },
  beforeDestroy () {
    EventBus.$off('page-loader')
  },
  computed: {
    uniqueIdentificationNumberErrors () {
      return this.getRetrieveValidationErrorsByName('uniqueIdentificationNumber')
    }
  },
  methods: {
    getRetrieveValidationErrorsByName (name) {
      if (!this.$v.retrieveUser[name].$dirty) return []
      return this.getValidationErrors('retrieveUser').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeRetrieve () {
      this.$v.retrieveUser.$touch()
      if (this.$v.retrieveUser.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.submitRetrieval()
    },
    submitRetrieval () {
      this.user = null
      this.pageLoader = true
      this.userId = this.retrieveUser.uniqueIdentificationNumber
      this.$http.get(Vue.$apiConfig.userGet + '/' + this.userId).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.crearRetrieveData()
          this.pageLoader = false
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.pageLoader = false
        })
    },
    submitRetrievalById () {
      this.user = null
      this.pageLoader = true
      this.userId = this.retrieveUser.identificationNumber
      this.$http.get(Vue.$apiConfig.userGet + '/' + this.userId).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.crearRetrieveData()
          this.pageLoader = false
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.pageLoader = false
        })
    },
    crearRetrieveData () {
      this.retrieveUser.uniqueIdentificationNumber = ''
      this.$v.retrieveUser.$reset()
    }
  },
  validations () {
    const retrieveRules = {}

    Object.assign(retrieveRules, {
      uniqueIdentificationNumber: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13)
      }
    })

    return {
      retrieveUser: retrieveRules
    }
  }
}
</script>

<style scoped>
  .v-card__text {
    font-size: 15px
  }
  .user-info-type {
    font-size: 16px
  }
  .user-info {
    font-size: 16px;
    font-weight: 600
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  .role-popout {
    background-color: #E0F2F1 !important;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .centered-label {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>
